import PropTypes from 'prop-types';
import { FunctionField, ReferenceField, TextField, useTranslate } from 'react-admin';
import { DetailsShow } from '@/components/global/drawers/DetailsShow.jsx';
import { CustomBooleanField } from '@/components/global/fields/CustomBooleanField.jsx';
import { CampaignTileImage } from '@/components/adsCampaings/CampaignTileImage.jsx';
import { AdsCampaignsPeriodItem } from '@/components/adsCampaings/AdsCampaignsPeriodItem.jsx';
import { AdsCampaignDeviceGroupsField, AdsCampaignDisplayHoursField } from '@/components/adsCampaings/AdsCampaingsTile.jsx';
import { AdsCampaignMoreActions } from '@/components/adsCampaings/AdsCampaignMoreActions.jsx';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';

export const AdvertisementShow = ({ handleClose, elementId }) => {
    const translate = useTranslate();

    return (
        <DetailsShow
            handleClose={handleClose}
            elementId={elementId}
            resource='ad'
            canView={permissions => canViewDetails('ad', permissions)}
            actions={<AdsCampaignMoreActions variant='details' handleClose={handleClose} />}
            footer={<CampaignTileImage />}
            showChangeHistory
        >
            <ReferenceField source='contractorId' reference='contractor' link={false} label={translate('common.contractor')}>
                <TextField source='name' />
            </ReferenceField>
            <TextField source='name' label={translate('common.name')} />
            <FunctionField label={translate('resources.adsCampaign.labels.period')} render={record => <AdsCampaignsPeriodItem record={record} />} />
            <CustomBooleanField source='isPermanent' label={translate('resources.adsCampaign.labels.permanentAd')} />
            <FunctionField label={translate('resources.adsCampaign.labels.displayHours')} render={() => <AdsCampaignDisplayHoursField />} />
            <CustomBooleanField source='isContinuous' label={translate('resources.adsCampaign.labels.continuous')} />
            <FunctionField label={translate('menu.deviceGroups')} render={() => <AdsCampaignDeviceGroupsField />} />
        </DetailsShow>
    );
};

AdvertisementShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
